/* Shared tab logic for featured-collection-tabs and multi-collection-list-grid.
   Replaces the per-section inline copies so the code is cached once. */
(function () {
  function initRoot(root) {
    if (!root || root.dataset.fcTabsInit) return;
    root.dataset.fcTabsInit = '1';

    var tabsRow = root.querySelector('.fc-tabs');
    var buttons = root.querySelectorAll('[data-tab-button]');
    var panels = root.querySelectorAll('[data-tab-panel]');

    // Toggle edge fades based on how far the pill row is scrolled.
    function updateFades() {
      if (!tabsRow) return;
      var scrollable = tabsRow.scrollWidth - tabsRow.clientWidth > 1;
      var atStart = tabsRow.scrollLeft <= 1;
      var atEnd = tabsRow.scrollLeft + tabsRow.clientWidth >= tabsRow.scrollWidth - 1;
      tabsRow.classList.remove('fc-fade-left', 'fc-fade-right', 'fc-fade-both');
      if (!scrollable) return;
      if (!atStart && !atEnd) tabsRow.classList.add('fc-fade-both');
      else if (!atEnd) tabsRow.classList.add('fc-fade-right');
      else if (!atStart) tabsRow.classList.add('fc-fade-left');
    }

    if (tabsRow) {
      tabsRow.addEventListener('scroll', updateFades, { passive: true });
      window.addEventListener('resize', updateFades);
      updateFades();
    }

    function activate(id) {
      buttons.forEach(function (b) {
        var on = b.getAttribute('data-tab-button') === id;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-tab-panel') === id);
      });
      // Nudge the carousel to recalculate now that its panel is visible.
      window.dispatchEvent(new Event('resize'));
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activate(btn.getAttribute('data-tab-button'));
        // Keep the selected pill comfortably in view within the scroll row.
        if (btn.scrollIntoView) {
          btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.fc-tabs').forEach(function (row) {
      initRoot(row.closest('.shopify-section') || row.parentElement);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
